// Art / Drawing category step images

import abstractAcrylicCh3S3 from '@/assets/step-images/abstract-acrylic-ch3-s3.jpg';
import cyanotypeCh3S5 from '@/assets/step-images/cyanotype-ch3-s5.jpg';
import drawFiveObjectsCh1S4 from '@/assets/step-images/draw-five-objects-ch1-s4.jpg';
import drawFiveObjectsCh2S1 from '@/assets/step-images/draw-five-objects-ch2-s1.jpg';
import drawFiveObjectsCh3S1 from '@/assets/step-images/draw-five-objects-ch3-s1.jpg';
import mocktailFlightCh1S5 from '@/assets/step-images/mocktail-flight-ch1-s5.jpg';
import mocktailFlightCh3S5 from '@/assets/step-images/mocktail-flight-ch3-s5.jpg';
import selfPortraitCh1S1 from '@/assets/step-images/self-portrait-ch1-s1.jpg';
import texturedStatementArtCh1S5 from '@/assets/step-images/textured-statement-art-ch1-s5.jpg';
import texturedStatementArtCh3S4 from '@/assets/step-images/textured-statement-art-ch3-s4.jpg';
import texturedStatementArtCh3S5 from '@/assets/step-images/textured-statement-art-ch3-s5.jpg';
import watercolorSceneCh3S4 from '@/assets/step-images/watercolor-scene-ch3-s4.jpg';
import watercolorSceneCh3S5 from '@/assets/step-images/watercolor-scene-ch3-s5.jpg';

import oneColorChallengeCh1S1 from '@/assets/step-images/one-color-challenge-ch1-s1.jpg';
import oneColorChallengeCh1S2 from '@/assets/step-images/one-color-challenge-ch1-s2.jpg';
import oneColorChallengeCh1S3 from '@/assets/step-images/one-color-challenge-ch1-s3.jpg';
import oneColorChallengeCh1S4 from '@/assets/step-images/one-color-challenge-ch1-s4.jpg';
import oneColorChallengeCh1S5 from '@/assets/step-images/one-color-challenge-ch1-s5.jpg';
import oneColorChallengeCh2S1 from '@/assets/step-images/one-color-challenge-ch2-s1.jpg';
import oneColorChallengeCh2S2 from '@/assets/step-images/one-color-challenge-ch2-s2.jpg';
import oneColorChallengeCh2S3 from '@/assets/step-images/one-color-challenge-ch2-s3.jpg';
import oneColorChallengeCh2S4 from '@/assets/step-images/one-color-challenge-ch2-s4.jpg';
import oneColorChallengeCh2S5 from '@/assets/step-images/one-color-challenge-ch2-s5.jpg';
import oneColorChallengeCh3S1 from '@/assets/step-images/one-color-challenge-ch3-s1.jpg';
import oneColorChallengeCh3S2 from '@/assets/step-images/one-color-challenge-ch3-s2.jpg';
import oneColorChallengeCh3S3 from '@/assets/step-images/one-color-challenge-ch3-s3.jpg';
import oneColorChallengeCh3S4 from '@/assets/step-images/one-color-challenge-ch3-s4.jpg';
import oneColorChallengeCh3S5 from '@/assets/step-images/one-color-challenge-ch3-s5.jpg';

import roomStillLifeCh1S1 from '@/assets/step-images/room-still-life-ch1-s1.jpg';
import roomStillLifeCh1S2 from '@/assets/step-images/room-still-life-ch1-s2.jpg';
import roomStillLifeCh1S3 from '@/assets/step-images/room-still-life-ch1-s3.jpg';
import roomStillLifeCh1S4 from '@/assets/step-images/room-still-life-ch1-s4.jpg';
import roomStillLifeCh1S5 from '@/assets/step-images/room-still-life-ch1-s5.jpg';
import roomStillLifeCh2S1 from '@/assets/step-images/room-still-life-ch2-s1.jpg';
import roomStillLifeCh2S2 from '@/assets/step-images/room-still-life-ch2-s2.jpg';
import roomStillLifeCh2S3 from '@/assets/step-images/room-still-life-ch2-s3.jpg';
import roomStillLifeCh2S4 from '@/assets/step-images/room-still-life-ch2-s4.jpg';
import roomStillLifeCh2S5 from '@/assets/step-images/room-still-life-ch2-s5.jpg';
import roomStillLifeCh3S1 from '@/assets/step-images/room-still-life-ch3-s1.jpg';
import roomStillLifeCh3S2 from '@/assets/step-images/room-still-life-ch3-s2.jpg';
import roomStillLifeCh3S3 from '@/assets/step-images/room-still-life-ch3-s3.jpg';
import roomStillLifeCh3S4 from '@/assets/step-images/room-still-life-ch3-s4.jpg';
import roomStillLifeCh3S5 from '@/assets/step-images/room-still-life-ch3-s5.jpg';

import mixedMediaCollageCh1S1 from '@/assets/step-images/mixed-media-collage-ch1-s1.jpg';
import mixedMediaCollageCh1S2 from '@/assets/step-images/mixed-media-collage-ch1-s2.jpg';
import mixedMediaCollageCh1S3 from '@/assets/step-images/mixed-media-collage-ch1-s3.jpg';
import mixedMediaCollageCh1S4 from '@/assets/step-images/mixed-media-collage-ch1-s4.jpg';
import mixedMediaCollageCh1S5 from '@/assets/step-images/mixed-media-collage-ch1-s5.jpg';
import mixedMediaCollageCh2S1 from '@/assets/step-images/mixed-media-collage-ch2-s1.jpg';
import mixedMediaCollageCh2S2 from '@/assets/step-images/mixed-media-collage-ch2-s2.jpg';
import mixedMediaCollageCh2S3 from '@/assets/step-images/mixed-media-collage-ch2-s3.jpg';
import mixedMediaCollageCh2S4 from '@/assets/step-images/mixed-media-collage-ch2-s4.jpg';
import mixedMediaCollageCh2S5 from '@/assets/step-images/mixed-media-collage-ch2-s5.jpg';
import mixedMediaCollageCh3S1 from '@/assets/step-images/mixed-media-collage-ch3-s1.jpg';
import mixedMediaCollageCh3S2 from '@/assets/step-images/mixed-media-collage-ch3-s2.jpg';
import mixedMediaCollageCh3S3 from '@/assets/step-images/mixed-media-collage-ch3-s3.jpg';
import mixedMediaCollageCh3S4 from '@/assets/step-images/mixed-media-collage-ch3-s4.jpg';
import mixedMediaCollageCh3S5 from '@/assets/step-images/mixed-media-collage-ch3-s5.jpg';

export const ART_DRAWING_IMAGES: Record<string, string> = {
  'abstract-acrylic-ch3-s3': abstractAcrylicCh3S3,
  'cyanotype-ch3-s5': cyanotypeCh3S5,
  'draw-five-objects-ch1-s4': drawFiveObjectsCh1S4,
  'draw-five-objects-ch2-s1': drawFiveObjectsCh2S1,
  'draw-five-objects-ch3-s1': drawFiveObjectsCh3S1,
  'mocktail-flight-ch1-s5': mocktailFlightCh1S5,
  'mocktail-flight-ch3-s5': mocktailFlightCh3S5,
  'self-portrait-ch1-s1': selfPortraitCh1S1,
  'textured-statement-art-ch1-s5': texturedStatementArtCh1S5,
  'textured-statement-art-ch3-s4': texturedStatementArtCh3S4,
  'textured-statement-art-ch3-s5': texturedStatementArtCh3S5,
  'watercolor-scene-ch3-s4': watercolorSceneCh3S4,
  'watercolor-scene-ch3-s5': watercolorSceneCh3S5,
  'one-color-challenge-ch1-s1': oneColorChallengeCh1S1,
  'one-color-challenge-ch1-s2': oneColorChallengeCh1S2,
  'one-color-challenge-ch1-s3': oneColorChallengeCh1S3,
  'one-color-challenge-ch1-s4': oneColorChallengeCh1S4,
  'one-color-challenge-ch1-s5': oneColorChallengeCh1S5,
  'one-color-challenge-ch2-s1': oneColorChallengeCh2S1,
  'one-color-challenge-ch2-s2': oneColorChallengeCh2S2,
  'one-color-challenge-ch2-s3': oneColorChallengeCh2S3,
  'one-color-challenge-ch2-s4': oneColorChallengeCh2S4,
  'one-color-challenge-ch2-s5': oneColorChallengeCh2S5,
  'one-color-challenge-ch3-s1': oneColorChallengeCh3S1,
  'one-color-challenge-ch3-s2': oneColorChallengeCh3S2,
  'one-color-challenge-ch3-s3': oneColorChallengeCh3S3,
  'one-color-challenge-ch3-s4': oneColorChallengeCh3S4,
  'one-color-challenge-ch3-s5': oneColorChallengeCh3S5,
  'room-still-life-ch1-s1': roomStillLifeCh1S1,
  'room-still-life-ch1-s2': roomStillLifeCh1S2,
  'room-still-life-ch1-s3': roomStillLifeCh1S3,
  'room-still-life-ch1-s4': roomStillLifeCh1S4,
  'room-still-life-ch1-s5': roomStillLifeCh1S5,
  'room-still-life-ch2-s1': roomStillLifeCh2S1,
  'room-still-life-ch2-s2': roomStillLifeCh2S2,
  'room-still-life-ch2-s3': roomStillLifeCh2S3,
  'room-still-life-ch2-s4': roomStillLifeCh2S4,
  'room-still-life-ch2-s5': roomStillLifeCh2S5,
  'room-still-life-ch3-s1': roomStillLifeCh3S1,
  'room-still-life-ch3-s2': roomStillLifeCh3S2,
  'room-still-life-ch3-s3': roomStillLifeCh3S3,
  'room-still-life-ch3-s4': roomStillLifeCh3S4,
  'room-still-life-ch3-s5': roomStillLifeCh3S5,
  'mixed-media-collage-ch1-s1': mixedMediaCollageCh1S1,
  'mixed-media-collage-ch1-s2': mixedMediaCollageCh1S2,
  'mixed-media-collage-ch1-s3': mixedMediaCollageCh1S3,
  'mixed-media-collage-ch1-s4': mixedMediaCollageCh1S4,
  'mixed-media-collage-ch1-s5': mixedMediaCollageCh1S5,
  'mixed-media-collage-ch2-s1': mixedMediaCollageCh2S1,
  'mixed-media-collage-ch2-s2': mixedMediaCollageCh2S2,
  'mixed-media-collage-ch2-s3': mixedMediaCollageCh2S3,
  'mixed-media-collage-ch2-s4': mixedMediaCollageCh2S4,
  'mixed-media-collage-ch2-s5': mixedMediaCollageCh2S5,
  'mixed-media-collage-ch3-s1': mixedMediaCollageCh3S1,
  'mixed-media-collage-ch3-s2': mixedMediaCollageCh3S2,
  'mixed-media-collage-ch3-s3': mixedMediaCollageCh3S3,
  'mixed-media-collage-ch3-s4': mixedMediaCollageCh3S4,
  'mixed-media-collage-ch3-s5': mixedMediaCollageCh3S5,
};
